import { Space } from "antd";
import { FC } from "react";
import Box from "../../../components/Box";
import Container from "../../../components/Container";
import MonthYear from "../../../components/MonthYear";
import Button from "../../../components/UI/Button";
import { useLoading } from "../../../context/LoadingProvider/useLoading";
import useMonthYear from "../../../hooks/useMonthYear";
import { getBingoLBPMonthly } from "../../../services/reports";
import { Output } from "../../../services/types";
import dayjs from "dayjs";

const BingoLBPMonthly: FC = () => {
  const loading = useLoading();

  const { month, year, years, setMonth, setYear } = useMonthYear(2014);

  const refreshReport = async () => {
    loading.addLoading();

    await getBingoLBPMonthly({
      output: Output.PDF,
      month: dayjs()
        .set("date", 1)
        .set("month", Number(month))
        .set("year", Number(year))
        .format("YYYY-MM-DD"),
    });

    loading.removeLoading();
  };

  return (
    <Container>
      <Box backgroundColor="white" padding="1.1em 1.8em">
        <Space direction="horizontal" size="middle" wrap>
          <MonthYear
            month={month as string}
            year={year}
            years={years}
            onMonthChange={setMonth}
            onYearChange={setYear}
          />

          <Button type="primary" onClick={() => refreshReport()}>
            Save as PDF
          </Button>
        </Space>
      </Box>
    </Container>
  );
};

export default BingoLBPMonthly;
